import { message } from 'antd'
import axios, { AxiosError } from 'axios'
import i18n from '../i18n'

interface ICustomStatusMessages {
  [key: number]: string
}

const statusCodeMap: ICustomStatusMessages = {
  401: i18n.t('api_error_401'),
  403: i18n.t('api_error_403'),
  404: i18n.t('api_error_404'),
  408: i18n.t('api_error_timeout'),
  500: i18n.t('api_error_500'),
  503: i18n.t('api_error_503'),
  0: i18n.t('api_error_offline'),
  600: i18n.t('api_error_unknown'),
}

const getTimeoutOrUnknownStatusCode = (error: AxiosError) => {
  // Axios timeouts the request because was longer than the seconds established.
  if (error.code === 'ECONNABORTED') {
    return 408
  } else if (!error.response) {
    // Network error -> Server is down
    return 503
  } else {
    // Unknown error, CORS maybe
    return 600
  }
}

const getStatusCodeMessage = (error: AxiosError, customStatusCodeMessages: ICustomStatusMessages = {}) => {
  let errorStatusCode: number

  if (error.response === undefined) {
    errorStatusCode = getTimeoutOrUnknownStatusCode(error)
  } else {
    errorStatusCode = error.response.status
  }

  const errorsMessage = { ...statusCodeMap, ...customStatusCodeMessages }

  return errorsMessage[errorStatusCode] || errorsMessage[600]
}

const showErrorMessage = (error: AxiosError, customStatusCodeMessages: ICustomStatusMessages = {}) => {
  if (!axios.isCancel(error)) {
    message.error(getStatusCodeMessage(error, customStatusCodeMessages))
  } else {
    if (process.env.NODE_ENV !== 'production') {
      let messageLog: string

      if (error.message) {
        messageLog = `, message:: ${error.message}`
      } else {
        messageLog = 'without any message'
      }

      // eslint-disable-next-line
      console.log(`The request was cancelled ${messageLog}`)
    }
  }
}

export default showErrorMessage
